import moment from "moment-timezone";

export const monthlyChartInterval = (year, month, birthDate, birthTZ) => {
    const dob = moment(birthDate).tz(birthTZ);
    const birthDay = dob.date();

    const startMonth = month - 1
    const endMonth = month < 12 ? Number(month) : 0

    // ---- START DATE (no timezone used) ----
    let start = moment({ year, month: startMonth, day: birthDay });

    if (!start.isValid() || start.month() !== startMonth) {
        start = moment({ year, month: startMonth }).endOf("month");
    }

    // Set start time → 00:00:00 in local moment
    // start = start.hour(0).minute(0).second(0);

    // ---- END DATE (no timezone used) ----
    let end = moment({ year, month: endMonth, day: birthDay });

    if (!end.isValid() || end.month() !== endMonth) {
        end = moment({ year, month: endMonth }).endOf("month");
    } else {
        end = end.subtract(1, "day");
    }

    // One day before next-month birth date

    // Set end time → 23:59:59
    // end = end.hour(23).minute(59).second(59);

    // // ---- Convert both to UTC ----
    // const startUTC = start.clone().utc();
    // const endUTC = end.clone().utc();
    return {
        start,
        end,
    }
    // return {
    //     start: startUTC.format("YYYY-MM-DD HH:mm:ss"),
    //     end: endUTC.format("YYYY-MM-DD HH:mm:ss")
    // };
};
